import React, { useState, useEffect } from "react";
import Page from "./page";
import { obtenerResponsables, eliminarResponsable } from "../requestResponsable";
import XLSX from "xlsx";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

function Index(props) {
	const [Responsables, SetResponsables] = useState();
	const [DialogOpen, SetDialogOpen] = useState(false);
	const [ItemSeleccionado, SetItemSeleccionado] = useState(null);
	const { usuarioSesion } = useSelector(state => ({
		usuarioSesion: state.usuarioSesion
	}));
	const notistack = useSnackbar();

	useEffect(() => {
		obtenerResponsables()
			.then(responsables => SetResponsables(responsables))
			.catch(error => {
				console.error(error);
				SetResponsables([]);
			});
	}, []);

	const handleShowDialog = (responsableID) => {
		SetDialogOpen(true);
		SetItemSeleccionado(responsableID);
	}

	/**
	 * Handler para eliminar un responsable.
	 */
	const handleEliminar = () => {
		eliminarResponsable(ItemSeleccionado)
			.then(response => {
				console.log("Responsable eliminado exitosamente.", response);
				let mensajeExito = notistack.enqueueSnackbar("Responsable eliminado exitosamente.", {
					variant: "success",
					anchorOrigin: { vertical: "bottom", horizontal: "center" },
					action: <IconButton onClick={() => notistack.closeSnackbar(mensajeExito)}><Close /></IconButton>
				});
			})
			.catch(error => {
				console.error("Error al intentar eliminar el responsable", error);
				let mensajeError = notistack.enqueueSnackbar("Error al intentar eliminar el responsable", {
					variant: "error",
					anchorOrigin: { vertical: "bottom", horizontal: "center" },
					action: <IconButton onClick={() => notistack.closeSnackbar(mensajeError)}><Close /></IconButton>
				});
			})
			.finally(() => {
				SetDialogOpen(false);
				SetItemSeleccionado(null);
			});
	}

	/**
	 * Handler para cancelar la eliminación.
	 */
	const handleCancelarEliminar = () => {
		SetDialogOpen(false);
		SetItemSeleccionado(null);
	}

	/**
	 * Hanlder para exportar datos con formato Excel.
	 */
	const handleExport = () => {
		const wb = XLSX.utils.book_new();
		let exportData = Responsables.map(r => ({
			nombre: r.persona.nombre_completo,
			run: r.persona.run,
			correlativo: r.correlativo,
		}));
		let ws = XLSX.utils.json_to_sheet(exportData);
		XLSX.utils.book_append_sheet(wb, ws, "Mandantes");
		XLSX.writeFile(wb, "mandantes.xlsx");
	}

	return (
		<Page
			usuario={usuarioSesion}
			responsables={Responsables}
			dialog_open={DialogOpen}
			handle_show_dialog={handleShowDialog}
			handle_eliminar={handleEliminar}
			handle_cancelar={handleCancelarEliminar}
			handle_export={handleExport}
		/>
	);
}

export default Index;